// extracted by mini-css-extract-plugin
export default {"_clear":"XZonaWZ6"};